module.exports = __webpack_public_path__ + "static/Football-white-ossystem-5e64dda559073ed93b46c3d5ac24dcd9.jpg";